import {Button, Card} from "antd"
import React from "react"
import {BottomSheet as BottomSheetSpring} from "react-spring-bottom-sheet"
import {ReactComponent} from "../../app"
import 'react-spring-bottom-sheet/dist/style.css'
import './bottom-sheet.sass'

export default class BottomSheet extends ReactComponent {
    cardRef = React.createRef()

    state = {
      expandOnContentDrag: true,
    }

  componentDidUpdate(prevProps) {
    if(this.props.active !== prevProps.active) {
      setTimeout(() => {
        this.handleScrollListener(this.props.active)
        this.handleTouchStartListener(this.props.active)
      },100)
    }

  }

  handleScrollListener = (enable) => {
    const cardBody = this.cardRef.current?.querySelector(".ant-card-body")

    if(cardBody)
      cardBody[enable ? "addEventListener" : "removeEventListener"]("scroll", this.isScrolled)

  }

  handleTouchStartListener = (enable) => {
    document[enable ? "addEventListener" : "removeEventListener"]('touchstart', this.handleTouchStart)
  }

  isScrolled = () => {
    const cardBody = this.cardRef.current?.querySelector(".ant-card-body")

    void this.updateState({expandOnContentDrag: cardBody.scrollTop <= 1})
  }

  handleTouchStart = (event) => {
    const target = event.target
    const isInBottomSheet = target.closest('.bottom-sheet')

    if(isInBottomSheet) {
      const activeEl = document.activeElement

      if(activeEl && ['INPUT', 'TEXTAREA'].includes(activeEl.tagName))
        activeEl.blur()

    }
  }


  render() {
    const {active, onClose, title, content, iconClose, closeable, className, cardClassName, cover, overlay, ...props} = this.props

    return (
      <>

        {overlay &&
          <div className={this.className(["bottom-sheet-overlay", active ? "active" : ""])}></div>
        }

        <BottomSheetSpring
          expandOnContentDrag={closeable !== false && this.state.expandOnContentDrag}
          blocking={false}
          className={this.className(["bottom-sheet", className])}
          open={active}
          onDismiss={onClose}
          {...props}>

          {iconClose && (
            <Button
              type="link"
              className="close"
              icon={typeof iconClose === 'string' ? <img src={iconClose} alt="Close" /> : iconClose}
              onClick={onClose} />
          )}

          {
            props.children

            ||

            (
              <Card
                ref={this.cardRef}
                className={this.className(["card-detail", cardClassName, cover ? "" : "card-without-cover"])}
                cover={cover}
              >

                <Card.Meta
                  title={title}
                  description={content} />

              </Card>
            )}

        </BottomSheetSpring>
      </>
    )
  }
}